<template>
  <v-container fluid class="pa-0">
    <v-card class="mr-3 ml-3 mb-3">

      <v-data-table
        class="mb-3 mx-3"
        :search="search"
        :headers="headers"
        :items="licenses"
        :item-class="
          (item) => (item.isDeleted ? 'deleted clickable-row' : 'clickable-row')
        "
        no-data-text="Пусто"
        no-results-text="Результатов нет"
        @click:row="editLicense"
        hide-default-footer
        :custom-sort="customSort"
        sort-by="id"
        :sort-desc="true"
        :loading="tableLoading"
        loading-text="Загрузка"
        :items-per-page="10"
      >

      <template v-slot:top="{ pagination, options, updateOptions }">
        <div fluid class="mb-0 pb-0 justify-start ">    
            <v-row class="align-center">
              <v-btn v-if="$store.getters.user.roleId === 0" color="green" dark to="/masters/add" class="mr-3 ml-3">
                <v-icon>mdi-plus</v-icon>
                Добавить
              </v-btn>
              
              <v-checkbox v-model="showingDeleted" color="green" label="Удаленные" class="mr-3"/>
              <v-checkbox v-model="hideExpired" color="green" label="Закончившиеся" class="mr-3"/>
              <v-checkbox v-model="showShowrooms" color="green" label="Шоурумы" class="mr-3"/>
              <v-spacer/>
              <v-menu  color="green" offset-y v-if="$store.getters.user.roleId === 0">
                <template v-slot:activator="{ on, attrs }">
                  <v-btn v-bind="attrs" v-on="on" class="mr-3" text>
                    <v-icon>mdi-file-download</v-icon>
                    Выгрузить в файл
                  </v-btn>
                </template>
                <v-list>
                  <v-list-item @click="exportToFile('csv')">csv</v-list-item>
                  <v-list-item @click="exportToFile('xlsx')">xlsx</v-list-item>
                </v-list>
              </v-menu>
            </v-row>

            <v-row align="center" no-gutters class="pt-0 mt-0">
              <v-text-field
                v-if="$store.getters.dealers"
                v-model="search"
                prepend-inner-icon="mdi-magnify"
                label="Поиск" 
                single-line
                hide-details
                class="pt-0 pb-0 mb-0 pt-5"
              />
              <v-data-footer
                :pagination="pagination"
                :options="options"
                @update:options="updateOptions"
                :items-per-page-options="[10, 50, 100, -1]"
                items-per-page-text="$vuetify.dataTable.itemsPerPageText"
              >
              </v-data-footer>
            </v-row>
          </div>
      </template>

        <template v-slot:header.id="{ header }">
          <span v-html="header.text"></span>
        </template>

        <template v-slot:item.licExpires="{ item }">
          <span
            :class="{
              expired:
                new Date(new Date().toISOString().slice(0, 10)) >
                new Date(item.licExpires),
            }"
          >
            <v-badge v-if="item.isSosActivated" color="red" content="SOS">
              {{ new Date(item.licExpires).toLocaleDateString() }}
            </v-badge>
            <template v-else>{{
              new Date(item.licExpires).toLocaleDateString()
            }}</template>
          </span>
        </template>
        <template v-slot:item.masterExpires="{ item }">
          <span
            :class="{
              expired:
                new Date(new Date().toISOString().slice(0, 10)) >
                new Date(item.masterExpires),
            }"
          >
            {{ new Date(item.masterExpires).toLocaleDateString() }}
          </span>
        </template>
        <template v-slot:item.isShowroom="{ item }">
          <v-simple-checkbox :value="item.isShowroom"/>
        </template>
        <template v-slot:item.actions="{ item }">
          <v-icon v-if="!item.isDeleted" @click.stop="deleteLicense(item)">
            mdi-delete
          </v-icon>
          <v-icon v-else @click.stop="restoreModule(item)">
            mdi-backup-restore
          </v-icon>
        </template>
        <template v-slot:item.actions="{ item }">
          <v-tooltip v-if="!item.isDeleted" top nudge-bottom="4">
            <template v-slot:activator="{ on, attrs }">
              <v-icon
                @click.stop="deleteLicenseConfirm(item)"
                v-bind="attrs"
                v-on="on"
              >
                mdi-delete
              </v-icon>
            </template>
            <span>Удалить</span>
          </v-tooltip>

          <v-tooltip v-else top nudge-bottom="4">
            <template v-slot:activator="{ on, attrs }">
              <v-icon
                @click.stop="restoreLicense(item)"
                v-bind="attrs"
                v-on="on"
              >
                mdi-backup-restore
              </v-icon>
            </template>
            <span>Восстановить</span>
          </v-tooltip>
        </template>
        <template v-slot:item.updateTime="{ item }">
          <span>{{ formatUpdateTime(item.updateTime) }}</span>
        </template>
      </v-data-table>
    </v-card>

    <confirmation-dialog
      ref="confirmation"
      title="Удаление Лицензии"
      agree-button="Удалить"
      disagree-button="Отмена"
      @agree="deleteLicense($event)"
    ></confirmation-dialog>
  </v-container>
</template>

<script>
import API from "@/axios/api";
import ConfirmationDialog from "@/components/ConfirmationDialog";

import FormatDateTime from "@/utils/time.js";

export default {
  components: {
    ConfirmationDialog,
  },
  data() {
    return {
      deletingLicenseId: "",

      tableLoading: true,
      search: "",
      showingDeleted: false,
      showShowrooms: true,
      hideExpired: false,
      headers: [
        {
          text: "Код <br>лицензии",
          align: "start",
          value: "id",
        },
        {
          text: "Объект",
          align: "start",
          value: "objectName",
        },
        {
          text: "Дилер",
          align: "start",
          value: "dealerName",
          width: 50
        },
        {
          text: "Модуль ПО",
          align: "start",
          value: "moduleName",
        },
        {
          text: "Кол-во",
          align: "start",
          value: "count",
        },
        {
          text: "Фичи",
          align: "start",
          value: "features",
        },
        {
          text: "Шоурум",
          align: "center",
          value: "isShowroom",
          sortable: false
        },
        {
          text: "Lic Date",
          align: "center",
          value: "licExpires",
        },
        {
          text: "Max Date",
          align: "center",
          value: "masterExpires",
        },
        {
          text: "Изменил",
          align: "center",
          value: "creatorName",
        },
        {
          text: "Дата последнего изменения",
          align: "start",
          value: "updateTime",
        },
        {
          text: "Действия",
          align: "center",
          value: "actions",
          sortable: false,
        },
      ],
    };
  },
  methods: {
    exportToFile(format) {
      const showingDeleted = this.showingDeleted;
      const showingShowrooms = this.showShowrooms;
      const hideExpired = this.hideExpired
      API.get(`licenses/reports?format=${format}&showingDeleted=${showingDeleted}&showingShowrooms=${showingShowrooms}&hideExpired=${!hideExpired}`, { responseType: 'blob' })
      .then(response => {
      if (response.status === 200) {
        let contentType = '';
        let fileExtension = '';
        if (format === 'csv') {
          contentType = 'text/csv';
          fileExtension = '.csv';
        } else if (format === 'xlsx') {
          contentType = 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet';
          fileExtension = '.xlsx';
        }
        const blob = new Blob([response.data], { type: contentType });
        const date = new Date();
        const currentDate = this.formatUpdateTime(date); 
        const filename = `Отчет лицензии ${currentDate}${fileExtension}`.replace(/:/g, '.');
        if (window.navigator.msSaveOrOpenBlob) {
          window.navigator.msSaveOrOpenBlob(blob, filename);
        } else {
          const url = window.URL.createObjectURL(blob);
          const link = document.createElement('a');
          link.href = url;
          link.setAttribute('download', filename);
          document.body.appendChild(link);
          link.click();
          window.URL.revokeObjectURL(url);
        }
        console.log('Файл успешно загружен');
      } else {
        console.error('Ошибка загрузки файла:', response.statusText);
      }
    })
    .catch(error => {
      console.error('Ошибка загрузки файла:', error);
    });
},
    customSort(items, index, isDesc) {
      if (index[0] === "licExpires") {
        items.sort((a, b) => {
          if (!isDesc[0]) {
            return new Date(a.licExpires) > new Date(b.licExpires) ? 1 : -1;
          } else {
            return new Date(a.licExpires) > new Date(b.licExpires) ? -1 : 1;
          }
        });
      } else if (index[0] === "masterExpires") {
        items.sort((a, b) => {
          if (!isDesc[0]) {
            return new Date(a.masterExpires) > new Date(b.masterExpires)
              ? 1
              : -1;
          } else {
            return new Date(a.masterExpires) > new Date(b.masterExpires)
              ? -1
              : 1;
          }
        });
      } else {
        items.sort((a, b) => {
          if (!isDesc[0]) {
            return a[index[0]] > b[index[0]] ? 1 : -1;
          } else {
            return a[index[0]] > b[index[0]] ? -1 : 1;
          }
        });
      }
      return items;
    },
    editLicense(license) {
      if (license.isDeleted) {
        this.$store.commit("showSnackbar", {
          color: "warning",
          text: "Лицензия удалена",
        });
      } else {
        this.$router.push("/licenses/" + license.id);
      }
    },
    deleteLicenseConfirm(license) {
      this.deletingObjectId = license.id;
      this.$refs.confirmation.showDialog(
        license.id,
        `Вы действительно хотите удалить Лицензию на Модуль <span class="highlighted">${license.moduleName}</span> для Объекта <span class="highlighted">${license.objectName}</span> ?`
      );
    },
    deleteLicense(licenseId) {
      console.log('qwerty', licenseId)
      API.get(`licenses/${licenseId}/delete`)
        .then((response) => {
          console.log(response.data);
          this.$store.dispatch("updateLicenses");
        })
        .catch((error) => {
          console.log(error);
          if (error.response.data.message)
            this.$store.commit("showSnackbar", {
              color: "error",
              text: error.response.data.message,
            });
        });
    },
    restoreLicense(license) {
      API.get(`licenses/${license.id}/restore`)
        .then((response) => {
          console.log(response.data);
          this.$store.dispatch("updateLicenses");
        })
        .catch((error) => {
          console.log(error);
          if (error.response.data.message)
            this.$store.commit("showSnackbar", {
              color: "error",
              text: error.response.data.message,
            });
        });
    },
    formatUpdateTime(time) {
      return FormatDateTime(time);
    },
  },
  computed: {
    licenses: function () {
      return this.$store.getters.licenses
        .filter((license) => this.showingDeleted ? true : !license.isDeleted)
        .filter((license) => this.showShowrooms || !license.isShowroom)
        .filter((license) => this.hideExpired || new Date(license.licExpires) > (new Date()).setHours(0,0,0,0));
    },
  },
  activated() {
    this.$store.commit("setCrumbs", [
      { text: "main", disabled: false, to: "/", exact: true },
      { text: "licenses", disabled: true },
    ]);
  },
  created() {
    this.$store.dispatch("updateLicenses").then(() => {
      this.tableLoading = false;
    });
  },
};
</script>

<style>
.deleted {
  background-color: #e5d4d4;
}

.deleted .expired {
  border: 1px #efefef solid;
}

.expired {
  background-color: #eccdcd;
  color: #000000;
  padding: 0.2rem 0.5rem;
  border-radius: 3px;
}
</style>
